import IcoMoon from '@/components/IcoMoon'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { useFeatureToggle } from '@/context/featureToggles'
import { useTranslation } from 'next-i18next'
import * as styles from './style'

const BadgeInfo = (): JSX.Element | null => {
  const { t } = useTranslation('badge')

  const enableBadges = useFeatureToggle('exp_badges')
  const showEncoreBadging = useFeatureToggle('showEncoreBadging')
  const showSessionFeatureIcons = useFeatureToggle('showSessionFeatureIcons')

  if (!enableBadges && !showSessionFeatureIcons && !showEncoreBadging) return null

  return (
    <Stack y className={`${styles.infoWrapper} mt-md mt-xl-gte-sm`}>
      <Text size="md" weight="lg">
        {t('info.title')}
      </Text>
      <Text size="xs" weight="sm" className="mb-sm">
        {t('info.description')}
      </Text>
      <Text size="xs" weight="sm" className="mb-sm">
        {t('info.description2')}
      </Text>
      <Stack y className={`${styles.badgeTipWrapper} ${styles.badgeTipCommunityContainer}`}>
        <Stack x alignItems="center" justifyContent="flex-start" className={styles.badgeTipHeader}>
          <div className={styles.iconContainer}>
            <IcoMoon icon="community" size={12} />
          </div>
          <Text size="xs" weight="sb" className={styles.badgeTipCommunityTitle}>
            {t('info.community.title')}
          </Text>
        </Stack>
        <Text size="xs" weight="sm">
          {t('info.community.description')}
        </Text>
      </Stack>
      {showEncoreBadging && (
        <Stack y className={`${styles.badgeTipWrapper} ${styles.badgeTipEncoreContainer}`}>
          <Stack x alignItems="center" justifyContent="flex-start" className={styles.badgeTipHeader}>
            <div className={styles.iconContainer}>
              <IcoMoon icon="encore" size={12} />
            </div>
            <Text size="xs" weight="sb" className={styles.badgeTipEncoreTitle}>
              {t('info.encore.title')}
            </Text>
          </Stack>
          <Text size="xs" weight="sm">
            {t('info.encore.description')}
          </Text>
        </Stack>
      )}
      {showSessionFeatureIcons && (
        <Stack y className={`${styles.badgeTipWrapper} ${styles.badgeTipVideoContainer}`}>
          <Stack x alignItems="center" justifyContent="flex-start" className={styles.badgeTipHeader}>
            <div className={styles.iconContainer}>
              <IcoMoon icon="video" size={12} />
            </div>
            <Text size="xs" weight="sb" className={styles.badgeTipVideoTitle}>
              {t('info.video.title')}
            </Text>
          </Stack>
          <Text size="xs" weight="sm">
            {t('info.video.description')}
          </Text>
        </Stack>
      )}
    </Stack>
  )
}
export default BadgeInfo
